<ng-container *ngIf="!isLoading">
  
  <div>
    <div class="container" id="print-section">
      <table class="table table-bordered">
        <thead>

          <tr>
            <th [attr.colspan]="totalth - 2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 5" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ - दिनांकानुसार संक्षिप्त 
               <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong> देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong> राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong> जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong> तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong> वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong> प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong> कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong> प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong> पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->

                        <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>

                    </small>
                </span>
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startdate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ enddate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

          <!-- <tr>
            <th *ngIf="totalth == 11" colspan="04" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 12" colspan="05" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 13" colspan="06" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 14" colspan="07" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 15" colspan="08" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 16" colspan="09" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 17" colspan="10" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 18" colspan="11" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 19" colspan="12" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 20" colspan="13" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 21" colspan="14" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 22" colspan="15" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 23" colspan="16" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 24" colspan="17" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 25" colspan="18" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 26" colspan="19" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 27" colspan="20" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 28" colspan="21" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 29" colspan="22" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 30" colspan="23" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 31" colspan="24" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 32" colspan="25" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 33" colspan="26" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 34" colspan="27" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 35" colspan="28" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 36" colspan="29" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 37" colspan="30" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 38" colspan="31" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 39" colspan="32" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 40" colspan="33" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 41" colspan="34" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 42" colspan="35" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 43" colspan="36" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 44" colspan="37" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 45" colspan="38" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 46" colspan="39" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 47" colspan="40" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 48" colspan="41" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>
            <th *ngIf="totalth == 49" colspan="42" class="largeHeading">हिंदुस्थान प्रकाशन संस्था - विवेक
              साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="4"></th>
            <th colspan="3">दिनांक - {{ today | date:'dd-MM-yyyy' }}</th>
          </tr> -->

          <!-- <tr>
            <th *ngIf="totalth == 10" colspan="03" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 11" colspan="04" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 12" colspan="05" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 13" colspan="06" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 14" colspan="07" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 15" colspan="08" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 16" colspan="09" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 17" colspan="10" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 18" colspan="11" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 19" colspan="12" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 20" colspan="13" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 21" colspan="14" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 22" colspan="15" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 23" colspan="16" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 24" colspan="17" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 25" colspan="18" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 26" colspan="19" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 27" colspan="20" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 28" colspan="21" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 29" colspan="22" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 30" colspan="23" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 31" colspan="24" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 32" colspan="25" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 33" colspan="26" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 34" colspan="27" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 35" colspan="28" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 36" colspan="29" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 37" colspan="30" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 38" colspan="31" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 39" colspan="32" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 40" colspan="33" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 41" colspan="34" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 42" colspan="35" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 43" colspan="36" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 44" colspan="37" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 45" colspan="38" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 46" colspan="39" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 47" colspan="40" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 48" colspan="41" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th *ngIf="totalth == 49" colspan="42" class="fontBold">
              <span class="left">वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ -</span> दिनांकानुसार
            </th>
            <th colspan="1"></th>
            <th colspan="3">दिनांक - {{ startdate | date:'dd-MM-yyyy' }}</th>
            <th colspan="3">पर्यंत - {{ enddate | date:'dd-MM-yyyy' }}</th>
          </tr> -->

          <tr>
            <th rowspan="2" style="font-weight: bold; font-size: 14px; word-wrap: break-word; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">दिनांकानुसार संक्षिप्त </th>
            <th colspan="4" style="font-weight: bold; font-size: 14px; word-wrap: break-word; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" colspan="4" style="font-weight: bold; font-size: 14px; word-wrap: break-word; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data.name }}</th>
            </ng-container>
          </tr>
          <tr>
            <th style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-bottom: 2px solid black;">रक्कम </th>
            <th style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-bottom: 2px solid black;">नवीन</th>
            <th style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-bottom: 2px solid black;">नूतनीकरण</th>
            <th style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-right: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" rowspan="1" style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-left: 2px solid black; border-bottom: 2px solid black;"> नवीन </th>
              <th *ngIf="data.isVisible" rowspan="1" style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-bottom: 2px solid black;"> नूतनीकरण </th>
              <th *ngIf="data.isVisible" rowspan="1" style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-bottom: 2px solid black;">एकूण </th>
              <th *ngIf="data.isVisible" rowspan="1" style="font-weight: bold; font-size: 13px; word-wrap: break-word; border-right: 2px solid black; border-bottom: 2px solid black;"> रक्कम </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
        
        <ng-container *ngFor="let data of finalData; let isLast = last">
          <!-- Individual data rows -->
          <!-- <tr *ngIf="data._isIndividual">
            <td style="text-align: right;">{{ data.crdt_voucher_date | date:'dd-MM-yyyy'}}</td>
            <td style="text-align: right;">{{ data.total_amt.toString().split('.')[0]}}</td>
            <td style="text-align: right;">{{ data.rcpt_type === 'New' ? 1 : 0 }}</td>
            <td style="text-align: right;">{{ data.rcpt_type === 'Renew' ? 1 : 0 }}</td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td style="text-align: right;">{{ data[getKey(sub.name) + '_नवीन'] }}</td>
                <td style="text-align: right;">{{ data[getKey(sub.name) + '_नूतनीकरण'] }}</td>
                <td style="text-align: right;">{{ data[getKey(sub.name) + '_एकूण'] }}</td>
              </ng-container>
            </ng-container>
          </tr> -->
        
          <!-- Subtotal row per date -->
          <tr *ngIf="data._isTotalRow" class="subtotal">
            <td style="text-align: right; border-left: 2px solid black; border-right: 2px solid black;">{{ data.crdt_voucher_date | date:'dd-MM-yyyy'}} </td>
            <td style="text-align: right;">{{ data['एकूण'] }}</td>
            <td style="text-align: right;">{{ data['नवीन'] }}</td>
            <td style="text-align: right;">{{ data['नूतनीकरण'] }}</td>
            <td style="text-align: right; border-right: 2px solid black;">{{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}</td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td style="text-align: right; border-left: 2px solid black;">{{ data[getKey(sub.name) + '_नवीन'] || 0 }}</td>
                <td style="text-align: right;">{{ data[getKey(sub.name) + '_नूतनीकरण'] || 0 }}</td>
                <td style="text-align: right;">{{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td>
                <td style="text-align: right; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_एकूण'] || 0 }}</td>
              </ng-container>
            </ng-container>
          </tr>
        
          <!-- Final grand total row -->
          <tr *ngIf="isLast && !data._isTotalRow && !data._isIndividual" class="grand-total">
            <td style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">{{ data.name }}</td>
            <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['एकूण'] }}</td>
            <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['नवीन'] }}</td>
            <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['नूतनीकरण'] }}</td>
            <td style="text-align: right; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}</td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">{{ data[getKey(sub.name) + '_नवीन'] || 0 }}</td>
                <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_नूतनीकरण'] || 0 }}</td>
                <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td>
                <td style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_एकूण'] || 0 }}</td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>

        
        </tbody>
      </table>
    </div>
  </div>

  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        Print
      </button> -->

       <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>
       
      <button class="noPrint" style="margin-top: 2% 2% 0 2%; margin-left: 2%" (click)="exportExcel('Datewise_Briefly_Subscription_Report')"
        mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint" style="margin-left: 2%">
        Close
      </button>
    </div>
  </div>

</ng-container>
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>